import { fetcher } from '@/services/graphql/fetcher/index';
import { Sort, VirtualCurrencyCode, type AnyObj } from '@/types';
import { businessUtils, storage } from '@/utils';
import {
  fetchGetOwnCustomLevelDocument,
  fetchGetLevelConfigDocument,
  fetchActiveOwnCustomerLevelDocument,
  fetchUpdateMemberInfoDocument,
} from '../graphql/docs';

/**
 * 获取会员等级
 */
export const fetchGeOwnCustomLevel = async () => {
  const res = await fetcher.query(fetchGetOwnCustomLevelDocument, {});
  return res.data.value?.getOwnCustomlevel;
};

/**
 * 获取会员等级配置
 */
export const fetchGetLevelConfig = async () => {
  const res = await fetcher.query(fetchGetLevelConfigDocument, {});
  return res.data.value?.getLevelConfig;
};

/**
 * 激活会员
 */
export const fetchActiveOwnCustomerLevel = async () => {
  const res = await fetcher.mutation(fetchActiveOwnCustomerLevelDocument, {});
  return res.data?.activeOwnCustomerLevel;
};

/**
 * 提交会员等级个人信息
 * @param variables
 */
export const fetchUpdateMemberInfo = async (variables: AnyObj) => {
  const res = await fetcher.mutation(fetchUpdateMemberInfoDocument, variables);
  return res.data?.updateMemberInfo;
};
